<template>
  <div id="page-wrap">
    <div v-if="false" id="rec-wrap">
      <div class="container-fluid odd">
        <div class="container">
          <div class="rec-grid">
            <div class="rec-grid-font">
              <h1>科研 教学 资源中心</h1>
              <p>面向中国科大师生，基于教育云，提供高效的存储、协作、过程管理</p>
            </div>
          </div>
          <div class="rec-grid">
            <div class="rec-grid-pic">
              <img src="@/assets/images/homebg01.svg" />
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid even">
        <div class="container">
          <div class="rec-grid">
            <div class="rec-grid-font">
              <h1>海量存储，简单可靠</h1>
              <p>提供对象存储方案，支持多平台的非结构化数据存储。</p>
            </div>
          </div>
          <div class="rec-grid">
            <div class="rec-grid-pic">
              <img src="@/assets/images/homebg02.svg" />
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid odd">
        <div class="container">
          <div class="rec-grid">
            <div class="rec-grid-font">
              <h1>全景加密，安全有方</h1>
              <p>
                全链路数据安全方案，本地加密解密， 确保在网络过程中数据安全性
                <router-link
                    :to="{ name: 'encryption' }"
                    class="encrypt glyphicon glyphicon-share-alt"
                ></router-link>
              </p>
            </div>
          </div>
          <div class="rec-grid">
            <div class="rec-grid-pic">
              <img src="@/assets/images/homebg03.svg" />
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid even">
        <div class="container">
          <div class="rec-grid">
            <div class="rec-grid-font">
              <h1>服务科大，助力科教</h1>
              <p>依托教育网，为中国科大广大师生、科研团队提供服务。</p>
            </div>
          </div>

          <div class="rec-grid">
            <div class="rec-grid-pic">
              <img src="@/assets/images/homebg04.svg" />
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid odd">
        <div class="container">
          <div class="rec-grid">
            <div class="rec-grid-font">
              <h1>欲善其事，先利其器</h1>
              <p>
                提供通用的工具集和过程管理服务，支持科研教学的定制化工具接入。
              </p>
            </div>
          </div>
          <div class="rec-grid">
            <div class="rec-grid-pic">
              <img src="@/assets/images/homebg05.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%;height: 100px;">

    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {
    this.$store.commit("SET_THEME", "");
    document.title = "睿客网 - 中国科学技术大学科研教学资源中心";
  },
};
</script>
